import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { ShCreateJobIcon, ShDashboardIcon, ShMyInterviewsIcon, ShMyJobsIcon, ShSettingsIcon } from 'assets/Icons';
import { INavLinks } from "shared/SharedModels";
import { ShIconPrimary, ShIconSecondary } from "shared/SharedStyles/styleConstants";

export const AppLayoutNavLinks: INavLinks[] = [
  {
    redirectTo: "/employer/dashboard",
    label: "Dashboard",
    icon: <ShDashboardIcon primaryColor={ShIconPrimary} secondaryColor={ShIconSecondary} />
  },
  {
    redirectTo: "/employer/job/new",
    label: "Create Job",
    icon: <ShCreateJobIcon primaryColor={ShIconPrimary} secondaryColor={ShIconSecondary} />
  },
  {
    redirectTo: "/employer/jobs",
    label: "My Jobs",
    icon: <ShMyJobsIcon primaryColor={ShIconPrimary} secondaryColor={ShIconSecondary} />
  },
  {
    redirectTo: "/employer/interviews",
    label: "My Interviews",
    icon: <ShMyInterviewsIcon primaryColor={ShIconPrimary} secondaryColor={ShIconSecondary} />
  },
  // Temporary, change to ShCalendarIcon
  {
    redirectTo: "/employer/calendar",
    label: "My Calendar",
    icon: <CalendarMonthIcon style={{ color: ShIconPrimary, transform: 'scale(1.3)' }} />
  },
  {
    redirectTo: "/employer/settings/account-information",
    label: "Settings",
    icon: <ShSettingsIcon primaryColor={ShIconPrimary} secondaryColor={ShIconSecondary} />
  },
]